      
import axios from "axios";


export const fetchData = (accountId) => async (dispatch) => {
    dispatch({type: "FETCH_LOCKDOWN_DETAILS_LOADING"});
    axios
    .get(`${process.env.REACT_APP_DEVICE_API_URL}/api/v1/getlatestjson?accountId=${accountId}`)
    .then((res) => {
        dispatch({type: "FETCH_LOCKDOWN_DETAILS_SUCCESS", payload: res.data});
    })
    .catch((err) => dispatch({type: "FETCH_LOCKDOWN_DETAILS_ERROR", payload: err}))
};